import React from "react";
import FileUploadField from "components/shared/form/fields/FileUploadField";
import TextEditor from "components/shared/form/fields/TextEditor";
import TextInput from "components/shared/form/fields/TextInput";

// @todo: add fields if needed
const FIELD_LOOKUP = {
  image: (props) => (
    <FileUploadField
      {...props}
      options={{
        isImage: true,
        multiple: false,
        selectExisting: false,
        storageDirectory: "images",
      }}
    />
  ),
  "text[multiline]": TextEditor,
  text: TextInput,
};

type TypeFieldsArgs = {
  type: string;
  label: string;
  name: string;
  multiline?: boolean;
  required?: boolean | string;
  hint?: string | null;
  maxLength?: number | null;
  options?: { label: string; value: string }[] | { [key: string]: any };
};

export default function TypeFields({ type, ...props }: TypeFieldsArgs) {
  const FieldComponent =
    FIELD_LOOKUP[`${type}${props.multiline ? "[multiline]" : ""}`];
  return <FieldComponent {...props} />;
}
